module.exports = __webpack_public_path__ + "img/aiimg8.39f423fb.png";